import React from 'react';
import ScrollToTop from 'react-scroll-to-top';

const ScrollTop = () => {
    return (
        <>
            <ScrollToTop smooth />
        </>
    );
};

export default ScrollTop;